import React from 'react';
import Hero from '../Hero';
import AboutSection from '../Section/AboutSection';
import Banner from '../Section/BannerSection';
import FeaturesSection from '../Section/FeaturesSection';
import AppointmentSection from '../Section/AppointmentSection';
import FaqSection from '../Section/FaqSection';
import { pageTitle } from '../../helpers/PageTitle';

const featureListData = [
  {
    iconSrc: '/images/home_1/compassion.svg',
    title: 'Empowerment',
    subTitle:
      'We are committed to helping individuals, families, and communities build the strength and skills to reach their full potential.',
  },
  {
    iconSrc: '/images/home_1/excellence.svg',
    title: 'Respect for Individuality',
    subTitle:
      'We recognize the uniqueness of each person and tailor our interventions to cater to their specific needs, values, and experiences.',
  },
  {
    iconSrc: '/images/home_1/respect.svg',
    title: 'Collaboration',
    subTitle: `We work hand-in-hand with clients, families, organizations and communities to achieve shared goals and lasting well-being.`,
  },
  {
    iconSrc: '/images/home_1/integrity.svg',
    title: 'Integrity',
    subTitle:
      'We uphold the highest ethical standards, promoting trust, confidentiality, and transparency in all our interactions.',
  },
  {
    iconSrc: '/images/home_1/teamwork.svg',
    title: 'Growth',
    subTitle:
      'We support holistic personal and collective growth, addressing mental, emotional, and social well-being to foster lasting harmony.',
  },
  {
    iconSrc: '/images/home_1/compassion.svg',
    title: 'Compassion',
    subTitle:
      'We approach every individual with empathy, kindness, and a non-judgmental understanding of their unique challenges.',
  },
];

const faqData = [
  {
    title: 'Do you only work with individuals, or do you also collaborate with organizations?',
    content:
      'We work with both individuals and organizations. Individuals can access therapy, while organizations can partner with us for tailored mental health trainings, workshops, and seminars.',
  },
  {
    title: '⁠Do you work with children, teens, or only adults?',
    content:
      'We work with teenagers and young adult individuals. Please contact us to determine which services suit your needs.',
  },
  {
    title: 'Do you offer online therapy sessions?',
    content:
      'Yes, we offer both in-person and online therapy options to cater to your convenience.',
  },
  {
    title: 'How do I book a therapy session, a workshop or training session for my organization?',
    content:
      'You can book an appointment by calling us, emailing, or using the booking form on our website.',
  },
  {
    title: 'Can workshops be customized for specific needs?',
    content:
      'Absolutely! We tailor workshops and trainings to meet the specific needs of your organization or group.',
  },
];


export default function Home() {
  pageTitle('Home');
  return (
    <>
      <Hero
        title="Inspiring Change. Influencing Growth."
        subTitle="Culturally responsive mental health and well-being services that empower individuals, families, and organisations to thrive."
        bgUrl="/images/home_1/Noohra-Services9.webp"
        imgUrl="/images/new/Mental health icon 09 Growth mind.png"
        videoBtnText="See how we work"
        videoUrl="https://www.youtube.com/embed/VcaAVWtP48A"
        infoList={[
          {
            title: 'Hotline',
            subTitle: '+234 803 873 8245',
            iconUrl: '/images/contact/icon_1.svg',
          },
          {
            title: 'Email',
            subTitle: 'noohraintegratedservices@gmail.com',
            iconUrl: '/images/icons/ambulance.svg',
          },
          {
            title: 'Location',
            subTitle: 'Abuja, Nigeria',
            iconUrl: '/images/icons/pin.svg',
          },
        ]}
        btnText="Book Now"
        btnUrl="/appointments"
      />
      <FeaturesSection sectionTitle="Our Values" data={featureListData} />

      <AboutSection
        imgUrl="/images/home_1/Noohra-Services7.webp"
        spiningImgUrl="/images/home_1/about_mini.svg"
        title="About Us"
        subTitle="NOOHRA INTEGRATED SERVICES"
        featureList={[
          {
            featureListTitle: '',
            featureListSubTitle:
              'We are committed to promoting mental health awareness and well-being through psychoeducation via seminars, webinars, workshops, and offering personalized therapy sessions.',
          },
        ]}
      />

      <Banner
        bgUrl="images/home_1/cta_bg.svg"
        imgUrl="/images/new/Mental health icon 13 Part of heart.png"
        title="Don’t Let Your Mental Health Take a Backseat"
        subTitle="Schedule an appointment with one of our experienced medical professionals today!"
      />

      <AppointmentSection
        sectionTitle="Appointment"
        sectionTitleUp="BOOK AN"
        imgUrl="/illustrations/Noohra-Services Hero8.webp"
      />

      <section className="py-16 md:py-24">
        <FaqSection
          data={faqData}
          sectionTitle="Usually Asked"
          sectionTitleUp="What People"
        />
      </section>
    </>
  );
}
